<template>
    <!-- 装修单详情 -->
    <div id="remodelDetail">
        <!-- 详情 -->
        <div v-if="type == 0">
            <van-cell title="收房合约编码" :value="remodelDetail.propertyContractNumber" />
            <van-cell title="房源编码" :value="remodelDetail.houseNumber" />
            <van-cell title="房源类型" :value="remodelDetail.houseType" />
            <van-cell title="地址" :value="remodelDetail.houseAddress" />
            <van-cell title="租期" :value="(remodelDetail.rentStartDate?remodelDetail.rentStartDate.slice(0,10):'')+ '到' + (remodelDetail.rentEndDate?remodelDetail.rentEndDate.slice(0,10):'')" />
            <van-cell title="成本租期" :value="(remodelDetail.startDate?remodelDetail.startDate.slice(0,10):'')+ '到' + (remodelDetail.endDate?remodelDetail.endDate.slice(0,10):'')" />
            <van-cell title="总成本" :value="remodelDetail.totalAmount" />
            <van-cell title="审批状态" :value="remodelStatusList[remodelDetail.status-1]" />
            <van-cell title="创建时间" :value="remodelDetail.createDate" />
            <van-cell title="创建人" :value="remodelDetail.creator" />
        </div>
        <!-- 审批 -->
        <van-steps direction="vertical" :active="0" active-color="#FD7E2D" active-icon="more" inactive-icon="checked" v-if="type == 1">
            <van-step v-for="item in trackRecordList" :key="item.id">
                <!-- 开始 -->
                <div v-if="item.taskStartEndType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item.actorTime">发起时间：{{item.actorTime}}</p>
                    </div>
                </div>
                <!-- 审批 -->
                <div v-else-if="item.taskType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item1.approvalStatus">审批结果：{{approvalStatusList[item1.approvalStatus-1]}}</p>
                        <p v-if="item1.remark">审批意见：{{item1.remark}}</p>
                        <p v-if="item1.approvalTime">处理时间：{{item1.approvalTime}}</p>
                        <p v-if="item1.createTime">到达时间：{{item1.createTime}}</p>
                    </div>
                </div>
                <!-- 抄送 -->
                <div v-else-if="item.taskType == 2">
                    <div>
                        <h4>
                            <span v-for="(item1,index1) in item.actors" :key="index1">
                                <span v-if="index1!=0">/</span>
                                {{item1.actorName}}
                            </span>
                        </h4>
                        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>
                    </div>
                </div>
                <!-- 结束 -->
                <div v-else>结束</div>
            </van-step>
        </van-steps>
        <van-form ref="form" label-width="110px" input-align="left" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5">
            <van-field label="审批意见" :border="false" />
            <van-field v-model="formData.remark" rows="2" autosize type="textarea" maxlength="50" placeholder="请输入审批意见" show-word-limit :rules="[{ required: true, message: '请输入审批意见' }]" />
        </van-form>
        <div v-if="$route.query.type" style="height:1.2rem;"></div>
        <div class="btn" v-if="$route.query.type">
            <van-button v-if="type == 0" @click="type = 1" type="primary">审批</van-button>
            <van-button v-if="type == 1" @click="type = 0" type="primary">详情</van-button>
            <van-button block type="primary" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(2)">驳回</van-button>
            <van-button block type="primary" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(1)">同意</van-button>
        </div>
        <!-- 加载 -->
        <div class="loading" v-if="loading"></div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    requestRemodelDetail,
    requestWorkflowDetail1,
    requestWorkflowSubmit,
      changeCompany, //钉钉消息进入详情页需切换公司 获取对应按钮权限
  requestButtomAuth,
} from "@/api";
import { mergeRowCol, accAdd, accSub, formatDate } from "@/utils/index";
export default {
    name: "remodelDetail",
    data() {
        return {
            active: 0,
            remodelDetail: {},
            //审批
            type: 0, //切换0.详情/1.审批
            saveLoad: false,
            trackRecordList: [{ status: "" }],
            loading: true,
            formData: {
                remark: ""
            }
        };
    },
    computed: {
        ...mapState(["remodelStatusList", "approvalStatusList"])
    },
    created() {
        this.getDetail();
        if (this.$route.query.type) {
            //待办进入
            this.getWorkflow();
        }
    },
    mounted() {},
    methods: {
        getDetail() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中..."
            });
            requestRemodelDetail(this.$route.query.id)
                .then(res => {
                  this.remodelDetail = res.data;
                  changeCompany({ companyId: res.data.companyId }).then(
                        (res) => {
                    this.$store.dispatch("resetAll", res.data);
                    requestButtomAuth().then((res) => {
                    this.$store.commit("SET_BUTTON", res.data || []);
                 });
            }
               );
                    this.loading = false;
                    toast1.clear();
                })
                .catch(err => {
                    toast1.clear();
                });
        },
        //查流程
        getWorkflow() {
            //审批待办
            requestWorkflowDetail1(this.$route.query.agentId).then(res => {
                this.trackRecordList = res.data ? res.data : [];
                this.trackRecordList[0].status == 5
                    ? (this.type = 1)
                    : (this.type = 0);
                // this.loading = false;
            });
        },
        accSub(num1, num2) {
            return accSub(num1, num2);
        },
        //审批提交
        submit(type) {
            let param = {
                agentId: this.$route.query.agentId,
                orderId: this.$route.query.orderId,
                approvalStatus: type,
                remark: this.formData.remark
            };
            if (type == 1) {
                //同意
                this.$dialog.confirm({
                    title: "提示",
                    message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    beforeClose: (action, done) => {
                        if (action === "confirm") {
                            this.saveLoad = true;
                            requestWorkflowSubmit(param)
                                .then(res => {
                                    this.$toast.success("审批成功");
                                    this.getWorkflow();
                                    this.saveLoad = false;
                                    done();
                                })
                                .catch(err => {
                                    this.saveLoad = false;
                                    done(false);
                                });
                        } else {
                            done();
                        }
                    }
                });
            } else {
                //驳回
                this.$refs["form"].validate().then(valid => {
                    this.$dialog.confirm({
                        title: "提示",
                        message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        beforeClose: (action, done) => {
                            if (action === "confirm") {
                                this.saveLoad = true;
                                requestWorkflowSubmit(param)
                                    .then(res => {
                                        this.$toast.success("审批成功");
                                        this.getWorkflow();
                                        this.saveLoad = false;
                                        done();
                                    })
                                    .catch(err => {
                                        this.saveLoad = false;
                                        done(false);
                                    });
                            } else {
                                done();
                            }
                        }
                    });
                });
            }
        }
    },
    watch: {}
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#remodelDetail {
    .colorC {
        color: $colorC;
    }
    .theme-color {
        color: $theme-color;
    }
    .btn {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        border-radius: 0.1rem;
        overflow: hidden;
        display: flex;
        /deep/.van-button {
            margin-left: -1px;
            border: none;
            border-radius: 0;
            flex: 1;
            padding: 0%;
            &:not(:last-child)::after {
                height: 50%;
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                border-right: 0.02667rem solid #ebedf0;
                z-index: 99;
            }
        }
    }
    .van-steps {
        text-align: left;
        padding-left: 2rem;
        /deep/.van-step__title {
            padding-left: 0.3rem;
            p {
                padding-top: 0.2rem;
            }
        }
    }
}
</style>
